export const AD_PER_NEWS = 5; // 新聞列表每5則新聞插入一則廣告
export const REPORT_NEWS_POS = 7; // 專題報導插在新聞列表第8則
